module.exports = __webpack_public_path__ + "img/card-bg.fd50cc73.png";